import { render, staticRenderFns } from "./instagram-photo-downloader.vue?vue&type=template&id=2cd9c7f3"
import script from "./instagram-photo-downloader.vue?vue&type=script&lang=js"
export * from "./instagram-photo-downloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports